import { Component, OnInit } from '@angular/core';
import { SeoService } from '../../services/seo.service';

@Component({
  selector: 'app-conditions-utilisation',
  standalone: true,
  imports: [],
  templateUrl: './conditions-utilisation.component.html',
  styleUrls: ['../../../assets/styles/pages-legales.css'],
})
export class ConditionsUtilisationComponent implements OnInit {
  constructor(private seo: SeoService) {}

  ngOnInit(): void {
    this.seo.updateMeta(
      "Conditions d'utilisation — Qaryos",
      "Découvrez les conditions d'utilisation du service Qaryos : cadre légal, règles d'utilisation et responsabilités de chaque partie."
    );
  }
}
